import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";

export default function NumberCell({ value }) {
  return value == null ? (
    <span className="tw:text-muted-foreground">{EM_DASH}</span>
  ) : (
    <span className="tw:block tw:truncate">{String(value)}</span>
  );
}
